import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import pic from "../../template/images/client.png";
import "./courseView.css";

const TabItems = (props) => {
  const { courseTabDetails } = props;
  console.log(typeof courseTabDetails.curriculum, "tabdetails");

const [curriculumValue, setCurriculumValue] = useState(false)
const [instructorValue, setInstructorValue] = useState(false)
const [bothValue, setBothValue] = useState(false)

const [newData, setNewData] = useState([])

useEffect(()=>{
  checkExisting();
},[courseTabDetails.curriculum]);




console.log("new",  curriculumValue)

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    props.returnTabClick(index);
  };
  const testdata = "uuuuuuuuuuuuuu";

  const data = [
    {
      tabIcon: '<i className="fa-solid fa-bookmark tab_icon"></i>',
      tabTitle: "Overview",
      // aboutExam: 'The examination seeks to create a common minimum knowledge benchmark for distributors of Portfolio Management Services (PMS). The certification aims to enhance the quality distribution and related support services in the PMS.',
      examObjectives: `${courseTabDetails.overview}`,
    },


    {
      tabIcon: courseTabDetails.curriculum == "null" ? "" : '<i className="fa-solid fa-clipboard tab_icon"></i>' ,
      tabTitle: courseTabDetails.curriculum == "null" ? "" : "Curriculum" ,
      // aboutExam: 'erre The examination seeks to create a common minimum knowledge benchmark for distributors of Portfolio Management Services (PMS). The certification aims to enhance the quality distribution and related support services in the PMS.',
      examObjectives: courseTabDetails.curriculum == "null" ?  "" : `${courseTabDetails.curriculum}`,
    } ,

    {
      tabIcon: '<i className="fa-solid fa-user tab_icon"></i>',
      tabTitle: "Instructor",
      // aboutExam: 'erre The examination seeks to create a common minimum knowledge benchmark for distributors of Portfolio Management Services (PMS). The certification aims to enhance the quality distribution and related support services in the PMS.',
      examObjectives: `${courseTabDetails.instructor}`,
    },
  ];

  const data1 = [
    {
      tabIcon: '<i className="fa-solid fa-bookmark tab_icon"></i>',
      tabTitle: "Overview",
      // aboutExam: 'The examination seeks to create a common minimum knowledge benchmark for distributors of Portfolio Management Services (PMS). The certification aims to enhance the quality distribution and related support services in the PMS.',
      examObjectives: `${courseTabDetails.overview}`,
    },


   

    {
      tabIcon: '<i className="fa-solid fa-user tab_icon"></i>',
      tabTitle: "Instructor",
      // aboutExam: 'erre The examination seeks to create a common minimum knowledge benchmark for distributors of Portfolio Management Services (PMS). The certification aims to enhance the quality distribution and related support services in the PMS.',
      examObjectives: `${courseTabDetails.instructor}`,
    },
  ];

  const data2 = [
    {
      tabIcon: '<i className="fa-solid fa-bookmark tab_icon"></i>',
      tabTitle: "Overview",
      // aboutExam: 'The examination seeks to create a common minimum knowledge benchmark for distributors of Portfolio Management Services (PMS). The certification aims to enhance the quality distribution and related support services in the PMS.',
      examObjectives: `${courseTabDetails.overview}`,
    },


   
    {
      tabIcon: courseTabDetails.curriculum == "null" ? "" : '<i className="fa-solid fa-clipboard tab_icon"></i>' ,
      tabTitle: courseTabDetails.curriculum == "null" ? "" : "Curriculum" ,
      // aboutExam: 'erre The examination seeks to create a common minimum knowledge benchmark for distributors of Portfolio Management Services (PMS). The certification aims to enhance the quality distribution and related support services in the PMS.',
      examObjectives: courseTabDetails.curriculum == "null" ?  "" : `${courseTabDetails.curriculum}`,
    } ,
  ];

  const data3 = [
    {
      tabIcon: '<i className="fa-solid fa-bookmark tab_icon"></i>',
      tabTitle: "Overview",
      // aboutExam: 'The examination seeks to create a common minimum knowledge benchmark for distributors of Portfolio Management Services (PMS). The certification aims to enhance the quality distribution and related support services in the PMS.',
      examObjectives: `${courseTabDetails.overview}`,
    },


   

    
  ];

  
  const checkExisting = () => {
    console.log(courseTabDetails.curriculum == "null", "pp")
    if(courseTabDetails.curriculum == "null" && courseTabDetails.instructor == null) {
      setBothValue(true)
      setNewData(data3)
    }  else if(courseTabDetails.curriculum == "null") {
      setCurriculumValue(true)
      setNewData(data1)
    } 
    
    else if(courseTabDetails.instructor == null) {
      setInstructorValue(true)
      setNewData(data2)
    }  
    else {
      setNewData(data)
    }
  }


console.log("new",  newData)





  const [selectedTab, setSelectedTab] = useState(0);
  return (
    <React.Fragment>
      <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
        <TabList>
          {
          // courseTabDetails.curriculum == "null" ?
          // data1.map((tab, index) => (
          //   <Tab
          //     key={index}
          //     dangerouslySetInnerHTML={{ __html: tab.tabIcon + tab.tabTitle }}
          //   />
          // ))
          // :
         
          newData.map((tab, index) => (
            <Tab
              key={index}
              dangerouslySetInnerHTML={{ __html: tab.tabIcon + tab.tabTitle }}
            />
          ))}
        </TabList>
        
            {/* <div className="instructor_main">
                            <div className="trainer_img">
                                <img src={pic}></img>
                            </div>
                            <div className="instructor_details">
                                <div className="ins_d_main">
                                    <span className="ins_title">Name : </span>
                                    <p className="ins_name ins_value">Testing Name</p>
                                </div>
                                <div className="ins_d_main">
                                    <span className="ins_title">Contact : </span>
                                    <p className="ins_email ins_value">testing@gmail.com</p>
                                </div>
                                <div className="ins_d_main">
                                    <span className="ins_title">Specialization : </span>
                                    <p className="ins_specialization ins_value">Computer Science</p>
                                </div>
                                <div className="ins_d_main_about">
                                    <span className="ins_title_about">About Instructor : </span>
                                    <p className="ins_description ins_value">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin</p>
                                </div>
                            </div>
                        </div> */}
        {
        // courseTabDetails.curriculum == "null" ?
        // data1.map((tab, index) => (
        //   <Tab
        //     key={index}
        //     dangerouslySetInnerHTML={{ __html: tab.tabIcon + tab.tabTitle }}
        //   />
        // ))
        // :
        
      
        newData.map((content, index) => (
          <TabPanel key={index}>
            <div
              className="tab_content_style"
              dangerouslySetInnerHTML={{ __html: content.examObjectives }}
            />
            {/* <div className="instructor_main">
                            <div className="trainer_img">
                                <img src={pic}></img>
                            </div>
                            <div className="instructor_details">
                                <div className="ins_d_main">
                                    <span className="ins_title">Name : </span>
                                    <p className="ins_name ins_value">Testing Name</p>
                                </div>
                                <div className="ins_d_main">
                                    <span className="ins_title">Contact : </span>
                                    <p className="ins_email ins_value">testing@gmail.com</p>
                                </div>
                                <div className="ins_d_main">
                                    <span className="ins_title">Specialization : </span>
                                    <p className="ins_specialization ins_value">Computer Science</p>
                                </div>
                                <div className="ins_d_main_about">
                                    <span className="ins_title_about">About Instructor : </span>
                                    <p className="ins_description ins_value">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin</p>
                                </div>
                            </div>
                        </div> */}
          </TabPanel>
        ))}
      </Tabs>
    </React.Fragment>
  );
};

export default TabItems;
